<ng-container>
	<!-- Title -->
	<div mat-dialog-title class="mat-dialog-header">
		<h2 class="dialog-title">Generate Checklist</h2>
	</div>
	<div mat-dialog-content>
		<!-- Form -->
		<form #checklistForm="ngForm" class="pv-form single-column" [formGroup]="formGroup" (ngSubmit)="submit()">
			<p>Generates a checklist of due Evaluations and Scheduled Actions for the Samples currently matching your filter.</p>

			<div class="flex-row">
				<mat-form-field appearance="standard" class="col-50">
					<mat-label>ISO Week</mat-label>
					<input matInput type="number" formControlName="isoWeek" min="1" max="53">
				</mat-form-field>
				<mat-form-field appearance="standard" class="col-50">
					<mat-label>Year</mat-label>
					<input matInput type="number" formControlName="isoYear" min="2000">
				</mat-form-field>
			</div>

			<p *ngIf="formGroup.hasError('weekYearPair')" class="text-warn">Enter both the week and year, or clear both to include all weeks.</p>

			<button mat-button type="button" (click)="clearWeek()">Clear week (include all weeks)</button>
		</form>
	</div>
	<!-- Actions -->
	<pv-form-actions mat-dialog-actions [form]="checklistForm" (cancel)="cancel()" saveAction="Generate">
	</pv-form-actions>
</ng-container>
